import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { loadGuidesByCategory } from '../../utils/cmsContentLoader';
import { Seo } from '../shared';
import KnowledgeHubLayout from '../explore/KnowledgeHubLayout';
import DiscoverySection from '../explore/DiscoverySection';
import OfficialCitation from '../explore/OfficialCitation';
import KnowledgeFlow from '../explore/KnowledgeFlow';
import { SAFETY_HUB } from '../../data/safetyEmergencyKnowledge';
import { LAST_VERIFIED } from '../../data/officialSources';
import '../../styles/explore.scss';
import '../../styles/guides.scss';

function SafetyHubPage() {
	const [guides, setGuides] = useState([]);
	const hub = SAFETY_HUB;

	useEffect(() => {
		loadGuidesByCategory('living_in_nepal').then(setGuides);
	}, []);

	return (
		<KnowledgeHubLayout
			touristSection="plan"
			touristCurrent="Safety"
			planStepId="safety"
			hideRelated
			seo={<Seo title="Safety & Emergency in Nepal" path="/safety" description="Tourist Police 1144, hospitals, altitude sickness, emergency numbers, and safety tips for travelers in Nepal." />}
			hero={{ image: hub.hero, eyebrow: hub.eyebrow, title: hub.title, lead: hub.lead }}
			quickFacts={hub.quickFacts}
			intro={{ title: 'Know before you need', text: 'Save these numbers on landing day.', body: 'Tourist Police (1144) is staffed with English-speaking officers at 28 locations across Nepal.' }}
			faqs={hub.faqs}
		>
			<div className="container" style={{ marginTop: '-1rem', marginBottom: '1.5rem' }}>
				<OfficialCitation sourceName="Tourist Police Nepal / NTB" sourceUrl="https://ntb.gov.np/en/plan-your-trip/before-you-come/tourist-police" lastVerified={hub.lastVerified || LAST_VERIFIED} subjectToChange />
			</div>
			<KnowledgeFlow title="Emergency journey" steps={[
				{ label: 'Arrived', to: '/arrival', desc: 'Save 1144 now' },
				{ label: 'Safety', to: '/safety', desc: 'You are here' },
				{ label: 'Insurance', to: '/plan/insurance', desc: 'Evacuation cover' },
				{ label: 'Trekking', to: '/plan/adventure', desc: 'Altitude prep' },
			]} />
			<DiscoverySection eyebrow="Every question" title="Safety & emergency guide">
				{hub.sections.map((s, i) => (
					<div key={s.id} className="info-card arrival-step-card" style={{ marginBottom: '1.25rem' }}>
						<div className="info-card__body">
							<span className="arrival-step-card__num">Section {i + 1}</span>
							<h3 className="info-card__title">{s.question}</h3>
							<p className="info-card__text">{s.answer}</p>
							{s.tips && <div className="arrival-tips"><p className="arrival-tips__label">Traveler tips</p><ul>{s.tips.map((t) => <li key={t}>{t}</li>)}</ul></div>}
							{s.source && <p className="section-source-tag">Official: <a href={s.source.url} target="_blank" rel="noopener noreferrer">{s.source.name}</a></p>}
						</div>
					</div>
				))}
			</DiscoverySection>
			<DiscoverySection eyebrow="Related guides" title="More practical guides" alt>
				<div className="guide-grid">
					{guides.filter((g) => g.slug && (g.slug.includes('scam') || g.slug.includes('sim') || g.slug.includes('currency'))).map((g) => (
						<Link key={g.slug} to={`/guides/${g.slug}`} className="guide-card">
							<h3 className="guide-card__title">{g.title}</h3>
							{g.summary && <p className="guide-card__summary">{g.summary}</p>}
						</Link>
					))}
				</div>
			</DiscoverySection>
		</KnowledgeHubLayout>
	);
}

export default SafetyHubPage;
